import PropTypes from 'prop-types'
import { useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../../helpers/toastErrorLog'

import * as archivoService from '../../servicios/archivoAdjuntoService'
import styles from './Upload.module.css'

const LIMIT_UPLOAD = 10

export const SubirArchivo = ({
  idUsuario,
  accept,
  idTipo,
  idDoc,
  onCarga,
  adjuntoPendiente = [],
  maxFiles = LIMIT_UPLOAD
}) => {
  const [archivoCargado, setArchivoCargado] = useState(null)
  const [subidasEnCurso, setSubidasEnCurso] = useState(0)
  const subiendo = subidasEnCurso > 0

  const upload = async (archivo) => {
    try {
      setSubidasEnCurso((n) => n + 1)
      const idDocValue = Number(idDoc) || 0
      const formData = new FormData()
      formData.append('nombre', archivo.name)
      formData.append('idUsuario', idUsuario)
      formData.append('archivo', archivo)
      formData.append('idTipo', idTipo)
      formData.append('idDoc', idDocValue)
      formData.append('idPath', String(idDocValue))

      const adjunto = await archivoService.subirArchivo(formData)

      setArchivoCargado(archivo.name)
      await fetchAdjunto(adjunto.data.adjunto.idAdjunto)
    } catch (error) {
      const mensaje = 'Error al subir el archivo.'
      toastErrorLog(error, mensaje, 'upload')
    } finally {
      setSubidasEnCurso((n) => n - 1)
    }
  }

  const fetchAdjunto = async (idAdjunto) => {
    const adjunto = await archivoService.buscarAdjuntosPorId(idAdjunto)

    const adjuntos = {
      ...adjunto,
      data: {
        ...adjunto.data,
        idAdjunto: idAdjunto
      }
    }

    onCarga?.(adjuntos)
  }

  const onDrop = (acceptedFiles) => {
    if (!acceptedFiles.length) {
      return
    }

    const adjuntos = Array.isArray(adjuntoPendiente) ? adjuntoPendiente : []
    const espacioDisponible = maxFiles - adjuntos.length

    if (espacioDisponible <= 0) {
      toast.error(`No puedes subir más archivos. Límite: ${maxFiles}`)
      return
    }

    if (acceptedFiles.length > espacioDisponible) {
      toast.error(
        `Solo puedes subir ${espacioDisponible} archivo${espacioDisponible !== 1 ? 's' : ''} más de los ${acceptedFiles.length} seleccionados`
      )
    }

    const archivosACargar = acceptedFiles.slice(0, espacioDisponible)
    archivosACargar.forEach((file) => upload(file))
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple: maxFiles > 1
  })

  const icono = subiendo
    ? 'fa-spinner fa-spin'
    : archivoCargado && !isDragActive
      ? 'fa-check-circle'
      : 'fa-cloud-upload'

  return (
    <div
      {...getRootProps()}
      className={`${styles.dropzone} ${isDragActive ? styles.dropzoneActive : ''} ${
        archivoCargado && !subiendo && !isDragActive ? styles.dropzoneOk : ''
      }`}
      aria-busy={subiendo}
    >
      <input {...getInputProps()} />
      <span className={styles.dropzoneIcono} aria-hidden="true">
        <i className={`fa ${icono}`} />
      </span>
      <p className={styles.fileName}>
        {isDragActive
          ? 'Soltá los archivos acá'
          : subiendo
            ? 'Subiendo archivos...'
            : archivoCargado
              ? `Archivo cargado: ${archivoCargado}`
              : 'Arrastrá o hacé clic para subir tus archivos'}
      </p>
      {!subiendo && !isDragActive && (
        <p className={styles.hint}>
          {archivoCargado
            ? 'Podés seguir agregando más archivos.'
            : 'Podés arrastrar los archivos o seleccionarlos desde tu computadora.'}
        </p>
      )}
      {!subiendo && !isDragActive && (
        <span className={styles.botonElegir}>
          <i className="fa fa-folder-open-o" aria-hidden="true" />
          Elegir archivos
        </span>
      )}
    </div>
  )
}

SubirArchivo.propTypes = {
  idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  accept: PropTypes.object,
  idTipo: PropTypes.string.isRequired,
  idDoc: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCarga: PropTypes.func,
  adjuntoPendiente: PropTypes.array.isRequired,
  maxFiles: PropTypes.number
}

SubirArchivo.defaultProps = {
  adjuntoPendiente: []
}
